import React, { useEffect, useState } from "react";
import AddNonParticipant from "../../library/AddNonParticipant/AddNonParticipant";
import {
  addNonParticipantReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./AddNonParticipant.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";

export const SmartAddNonParticipant = (props) => {
  const {
    studyId,
    roles,
    sites,
    addNonParticipant,
    onClose,
    checkIfEmailExists,
    emailExists,
    resetEmailExists,
  } = props;

  const [hasError, setHasError] = useState(false);

  const onSubmit = (formData) => {
    const { email, siteIds, role } = formData;

    setHasError(false);

    addNonParticipant(email, role, siteIds, studyId)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        onClose();
      })
      .catch((error) => {
        setHasError(true);
        sendNotification(error, ToastType.ERROR);
      });
  };

  useEffect(() => {
    return () => resetEmailExists();
  }, [resetEmailExists]);

  return (
    <AddNonParticipant
      roles={roles}
      sites={sites}
      onSubmit={onSubmit}
      onValidateEmail={checkIfEmailExists}
      hasError={hasError}
      emailExists={emailExists}
      resetEmailExists={resetEmailExists}
    />
  );
};

export default dynamic(
  "addNonParticipantReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({
      loginReducer: state.loginReducer,
    }),
  }),
  attachReducer(addNonParticipantReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartAddNonParticipant));
